import { API } from "@/services/api";
import { auditEndpoints } from "@/constant/endpoints";
import { AuditListParams, AuditListResponse } from "@/types/audit.types";
import { buildQueryString } from "@/utils/common.utils";

export const getAuditLogService = async (params: AuditListParams): Promise<AuditListResponse> => {
  const queryString = buildQueryString(params);
  const response = await API.Get<AuditListResponse>(`${auditEndpoints.audit}${queryString}`);
  if (response.data) return response.data;
  throw new Error(response.message);
};
